import React from "react";
import intl from "react-intl-universal";
import styled from "styled-components";
import commonUtils from "../../../script/utils/commonUtils";
import { mdiCancel, mdiHeartBroken, mdiRestart } from "@mdi/js";

import runnerRest from "../../../rest/runnerRest";

import { Svg } from "../../components/Svg";
import { Output } from "../../components/Output";
import { DropdownCaret, Option } from "../../components/DropdownCaret";

const LeftCellStyle = styled.td`
    text-align: left;
    > div {
        height: 12px;
    }
`;

const MenuCellStyle = styled.td`
  >div {
      margin-top: -3px;
      margin-bottom: -10px;
  }
`;

export const RunnerItem = ({ runner }) => {

    const onCancel = () => runnerRest.cancel(runner.id);

    const onRestart = () => runnerRest.shutdown(runner.id);

    return (
        <tr>
            <MenuCellStyle width="5">
                <DropdownCaret>
                    <Option
                        svgIcon={mdiCancel}
                        disabled={runner.shutdownRequested || !runner.active}
                        onClick={() => onCancel()}>
                        {intl.get("runners.cancel")}
                    </Option>
                    <Option
                        svgIcon={mdiRestart}
                        disabled={runner.shutdownRequested}
                        onClick={() => onRestart()}>
                        {intl.get("runners.restart")}
                    </Option>
                </DropdownCaret>
            </MenuCellStyle>
            <LeftCellStyle>{runner.name}</LeftCellStyle>
            <LeftCellStyle>{runner.username}</LeftCellStyle>
            <LeftCellStyle>{runner.companyName}</LeftCellStyle>
            <LeftCellStyle>{runner.subjectName}</LeftCellStyle>
            <LeftCellStyle>{runner.calculationType ? intl.get("enum.calculationType." + runner.calculationType) : ""}</LeftCellStyle>
            <LeftCellStyle>{commonUtils.isBlank(runner.calculationProgress) ? "" : runner.calculationProgress + "%"}</LeftCellStyle>
            <LeftCellStyle>
                <Output value={runner.active} type="boolean" />
            </LeftCellStyle>
            <LeftCellStyle>
                {runner.stale &&
                    <div>
                        <Svg path={mdiHeartBroken} size="16" />
                    </div>
                }
            </LeftCellStyle>
            <LeftCellStyle>
                <Output value={runner.shutdownRequested} type="boolean" />
            </LeftCellStyle>
        </tr>
    );
};